export default __webpack_public_path__ + "static/image2-dc8b35ee7ccecd5d5eb666dd9ebf3b2b.webp";